<template>
  <van-row>
    <van-sticky>
    <van-nav-bar
        title="洽谈室"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    </van-sticky>
<!--    <van-tabs v-model="active" animated v-if="isSDKReady">-->
<!--      <van-tab title="洽谈中" name="a" title-style="font-size:.35rem;">-->
        <chat-ting-list />
<!--      </van-tab>-->
<!--      <van-tab :title="userType==='company'?'推荐求职者':'推荐职位'" name="c">-->
<!--        <recommend-list />-->
<!--      </van-tab>-->
<!--    </van-tabs>-->
  </van-row>
</template>

<script>
import {isEmpty} from '@/utils/common'
import chatTingList from '@/components/chatTing/List'
// import RecommendList from '@/components/recommend/List'
import {mapState} from 'vuex'
export default {
  name: 'ChatView',
  components: {
    chatTingList,
    // RecommendList,
  },
  data() {
    return {
      active:'a',
    }
  },
  computed: {
    ...mapState('user', ['isLogin', 'isSDKReady', 'currentUserProfile','userID']),
    ...mapState('conversation', ['currentConversation']),
    ...mapState('common', ['apiIsLogin', 'userInfo','jobfairInfo','imUserInfo']),
    userType() {
      if (isEmpty(this.userID)) {
        return ''
      }
      const userId = this.userID
      let userIdData = userId.split('|')
      return userIdData[2]
    },
  },
  methods: {
    onClickLeft() {
      this.$router.push('/')
    },

  },
}
</script>

<style lang="stylus" scoped>
/*  .van-tabs__line {
    position: absolute;
    bottom: 15px;
    left: 0;
    z-index: 1;
    width: 33% !important;
    height: 2px !important;
    background-color: #1989fa !important;
    border-radius: 3px;
  }*/
.van-tab__text--ellipsis{
  font-size:.38rem !important;
}
</style>
